import { Component, Inject } from '@angular/core';
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-cvcompetencetypes',
    template: require('./cv-competence-types.component.html')
})
export class CvCompetenceTypes {

    isPermissionWriteOrAdmin: boolean;

    constructor(
        @Inject("cvCompetenceTypes") public cvCompetenceTypes: Nema.Crew.Model.CompetenceTypeCVMapping[],
        @Inject("cvCompetenceGroups") public cvCompetenceGroups: Nema.Crew.Model.CVCompetenceGroup[],
        crewPermissionsService: CrewPermissionsService) {

        crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);
    }

    public newEntityState = "app.settings.cvcompetencetypes.new";

    public editEntityState = "app.settings.cvcompetencetypes.detail";

    public entityName = "CV Competence";

    public entityNames = "CV Competences";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencetypes/cv-competence-types.component.ts